module.exports = __webpack_public_path__ + "static/img/webrtc.87a4638.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/webrtc.png
// module id = 8/HG
// module chunks = 1